export default {"src":"/_next/static/media/agenz_logo_pro.76f8f978.svg","height":35,"width":107,"blurWidth":0,"blurHeight":0};